/* eslint-disable lines-between-class-members */
import Component from '@glimmer/component';
import { getHandleHtmlString } from 'mewe/helpers/handle-html';
import { htmlSafe } from '@ember/template';
import { inject as service } from '@ember/service';

export default class WebThreeHandleReady extends Component {
  @service settings;

  userHandle = getHandleHtmlString(this.args.notification.web3Data.handle);

  get getNotificationText() {
    return htmlSafe(
      __('Your universal handle {handle} has been added to the Social Web.', {
        handle: this.userHandle,
      })
    );
  }
}
